"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Markdown = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.markdown.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable */ /* https://randyperkins2k.medium.com/writing-a-simple-markdown-parser-using-javascript-1f2e9449a558 */
// import markdowndata from "./readme.md";

class Markdown extends _react.Component {
  constructor(props) {
    super(props);
    // this.state = { markdown: '' };
  }
  /* 
  UNSAFE_componentWillMount() {  
  	fetch(this.props.data)
  		.then(response => { return response.text(); })
  		.then(text => { this.setState({ markdown: text }); })
  		.catch(err => console.log(err));
  }
  */
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "section-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "markdown",
      dangerouslySetInnerHTML: {
        __html: this.markdownParser(this.props.markdowndata)
      }
    }));
  }
  markdownParser(text) {
    const toHTML = text.replace(/^#{6}\s(.*$)/gim, '<h6>$1</h6>') // h6 tag
    .replace(/^#{5}\s(.*$)/gim, '<h5>$1</h5>') // h5 tag
    .replace(/^#{4}\s(.*$)/gim, '<h4>$1</h4>') // h4 tag
    .replace(/^#{3}\s(.*$)/gim, '<h3>$1</h3>') // h3 tag
    .replace(/^#{2}\s(.*$)/gim, '<h2>$1</h2>') // h2 tag
    .replace(/^#{1}\s(.*$)/gim, '<h1>$1</h1>') // h1 tag
    .replace(/(\=|\-|\*){3}/gim, '<hr />') // horizontal rule
    .replace(/!\[(.*?)\]\((.*?)\)/gim, "<img alt='$1' src='$2' />") // images
    .replace(/\[([^\[]+)\]\((.*)\)/gim, '<a href="$2">$1</a>') // links
    .replace(/^\*{1}\s+(.*$)/gim, '<ul><li>$1</li></ul>') // unordered list
    .replace(/<\/ul>\s?<ul>/g, '') // duplicate unordered list
    .replace(/^\d+\.\s+(.*$)/gim, '<ol><li>$1</li></ol>') // ordered list
    .replace(/<\/ol>\s?<ol>/g, '') // duplicate ordered list
    .replace(/\:\"(.*?)\"\:/gim, '<q>$1</q>') // quote
    .replace(/^\> (.*$)/gim, '<blockquote>$1</blockquote>') // blockquote
    .replace(/`(.*?)`/gim, '<code>$1</code>') // inline code
    .replace(/\*{2}(.*?)\*{2}/gim, '<b>$1</b>') // bold text
    .replace(/\*{1}(.*?)\*{1}/gim, '<i>$1</i>') // italic text
    .replace(/\~{2}(.*?)\~{2}/gim, '<b>$1</b>') // strikethrough
    .replace(/(^[A-z].+)/gim, '<p>$1</p>') // paragraphs
    //.replace(/\n$/gim, '<br />') // newline
    //.replace(//gim, '')
    ;

    return toHTML.trim(); // using trim method to remove whitespace
  }
}
exports.Markdown = Markdown;
_defineProperty(Markdown, "propTypes", {
  markdowndata: _propTypes.default.string.isRequired
});